module.exports = __webpack_public_path__ + "assets/images/project/header/image-background-header.jpg?v=2443465d";